/* eslint-disable import/prefer-default-export */
import { makeEntityScaffold } from '@classpass/saga-tools';

export const leaderboardJoinClass = makeEntityScaffold(
  'SAGA.API.LEADERBOARD_JOIN_CLASS',
  (client, alias, options = {}) => client.leaderboard.joinClass(alias, options),
  { defaultKey: 1 }
);

export const leaderboardLeaveClass = makeEntityScaffold(
  'SAGA.API.LEADERBOARD_LEAVE_CLASS',
  (client, alias, options = {}) => client.leaderboard.leaveClass(alias, options)
);

export const leaderboardUpdateHeartrate = makeEntityScaffold(
  'SAGA.API.LEADERBOARD_UPDATE_HEARTRATE',
  (client, classId, options = {}) => client.leaderboard.updateHeartrate(classId, options)
);

export const leaderboardUpdateClientStatus = makeEntityScaffold(
  'SAGA.API.LEADERBOARD_UPDATE_CLIENT_STATUS',
  (client, alias, options = {}) => client.leaderboard.updateStatus(alias, options)
);
